import { render } from "./EscritorioAvisosAutorizadasAsitur.vue?vue&type=template&id=32139a8c"
import script from "./EscritorioAvisosAutorizadasAsitur.vue?vue&type=script&lang=js"
export * from "./EscritorioAvisosAutorizadasAsitur.vue?vue&type=script&lang=js"

import "./EscritorioAvisosAutorizadasAsitur.vue?vue&type=style&index=0&id=32139a8c&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__